import axios from "axios"
import createAuthRefreshInterceptor from "axios-auth-refresh";
import router from "../router"
import { toast } from "vue-sonner"


const instance = axios.create({
 baseURL: '',
 headers: {
 'Accept': 'application/json',
 'Content-Type': 'application/json',
 'common': "",
 }
});

const refreshAuthLogic = failedRequest =>
  instance
    .post(process.env.VUE_APP_API_URL+"/token/refresh", {
      refresh: localStorage.getItem("refresh_token")
    })
    .then(tokenRefreshResponse => {
      console.log(tokenRefreshResponse);
      localStorage.setItem("innotoken", tokenRefreshResponse.data.token);
      localStorage.setItem("refresh_token", tokenRefreshResponse.data.refresh_token);
      failedRequest.response.config.headers["Authorization"] =
        "Bearer " + tokenRefreshResponse.data.token;
      return Promise.resolve();
    })
    .catch(error => {
      console.log("refresh fail");
      localStorage.removeItem("innotoken");
      localStorage.removeItem("refresh_token");
      //pushToLogin();

      if(router.currentRoute._value.name != "Confirm your account" && router.currentRoute._value.name != "login")router.push("/login");
      return Promise.reject(error);
    });
createAuthRefreshInterceptor(instance, refreshAuthLogic);

// Growth AI token gate: the backend signals an insufficient balance with
// { error: "insufficient_tokens" }. This deployment collapses error statuses to
// HTTP 200, so the body — not the status — is authoritative: we inspect both the
// success payload (200 body) and any real 4xx error. We surface a single dedicated
// toast and reject with error.__insufficientTokens so each caller's catch can bail
// out cleanly (its guard skips the generic toast).
const isInsufficientTokens = (data) =>
  !!data && typeof data === "object" && data.error === "insufficient_tokens";

instance.interceptors.response.use(
  (response) => {
    if (response && isInsufficientTokens(response.data)) {
      toast.error("You don't have enough tokens. Contact us to upgrade.");
      const err = new Error("insufficient_tokens");
      err.__insufficientTokens = true;
      err.response = response;
      return Promise.reject(err);
    }
    return response;
  },
  (error) => {
    const data = error && error.response && error.response.data;
    if (isInsufficientTokens(data)) {
      toast.error("You don't have enough tokens. Contact us to upgrade.");
      error.__insufficientTokens = true;
    }
    return Promise.reject(error);
  }
);

export default instance;
